<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { getTestServerCdkeyApi, lotteryTestSeverCdkeyApi } from '@/api/test-server/'
import type { TestServerCdkeyRecordType } from '@/api/test-server/types'
import { copyText } from '@/utils/copy-text'
import { dayjs } from 'element-plus'
import { useUserStore } from '@/stores/modules/user'

const userStore = useUserStore()

const info = ref<TestServerCdkeyRecordType | null>()
onBeforeMount(async () => {
  const res = await getTestServerCdkeyApi()
  info.value = res
})

async function handleLottery() {
  if (dayjs().isBefore('2026-04-05 00:00:00') || dayjs().isAfter('2026-04-12 00:00:00')) return ElMessage.warning('未在抽取开放时间')
  if (dayjs(userStore.created).isAfter('2026-03-01 00:00:00')) return ElMessage.warning('新号暂不允许参与，请期待下次招募')
  const key = await lotteryTestSeverCdkeyApi()
  info.value = {
    key,
    userId: 0,
    result: key ? 1 : 0,
  }
}
</script>

<template>
  <div class="test-server-cdkey affix">
    <h4>* 测试服主要用于新版本的功能测试，实际内容与正式服无异，若您愿意协助游戏开发，欢迎加入测试服</h4>
    <p>资格抽取规则：</p>
    <p>1. 2026-03-01 之前创建的账号可参与，根据您的注册时间、会员等级等，将改变抽奖概率</p>
    <p>2. 本次开放 <span class="grow">50</span>份资格，抽完即止</p>
    <p>3. 抽中时，您将获得测试服激活码，用于测试服注册</p>
    <p>4. 抽取时间：2026-04-05 00:00:00 ~ 2026-04-12 00:00:00</p>

    <div class="border-wrap">
      <div class="result">
        <h3>抽取结果：{{ info ? '已抽取' : '未抽取' }}</h3>
        <template v-if="info?.key">
          <p style="color: red; font-weight: bold; text-align: center">!! 请勿泄露您的激活码 !!</p>
          <p>
            恭喜中奖：<br />
            您的激活码：{{ info.key }}
            <el-button type="primary" size="small" plain style="margin-left: 10px" @click="copyText(info.key)">复制</el-button>
          </p>
          <p>测试服地址：<a href="https://aring.cc/awakening-of-war-soul-ol-test/">https://aring.cc/awakening-of-war-soul-ol-test/</a></p>
          <p>
            测试服群号：753722049（注册后凭id+昵称入群）
            <el-button type="primary" size="small" plain style="margin-left: 10px" @click="copyText('753722049')">复制</el-button>
          </p>
        </template>
        <p v-if="info && !info.key" style="text-align: center">未中奖</p>
      </div>
      <el-button type="success" plain style="width: 100%" @click="handleLottery" :disabled="Boolean(info)">{{ info ? '已抽取' : '抽！' }}</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.test-server-cdkey {
  .border-wrap {
    padding: 10px;
    .result {
      p {
        display: block;
        align-items: center;
        user-select: auto;
      }
    }
  }
}
</style>
